export const portfolioPageData = {
  banner: {
    backgroundImage: "/images/portfolio-banner-bg-image.png",
    mainHeading: "Our work, your eyes, it's a love story",
    content: "We make difference with better equipment & dedication",
    contactUsLink: "/contact-us",
    buttonText: "Let's Connect",
  },
  seo: {
    title: "Portfolio | Explore Bitsclan's Successful Software Projects",
    description: "Discover Bitsclan's diverse portfolio of successful software development projects across industries. See how we deliver value & innovation",
  },
  developingSolution: {
    heading: "Clients Who Trust With Us Their Security",
  },
};